__turbopack_context__.v({
  "addressText": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__addressText",
  "bodyText": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__bodyText",
  "contactBodyText": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__contactBodyText",
  "contactInfoRow": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__contactInfoRow",
  "contactInfoRows": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__contactInfoRows",
  "header": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__header",
  "infoButton": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__infoButton",
  "left": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__left",
  "orderFormat": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__orderFormat",
  "orderFormatsWrapper": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__orderFormatsWrapper",
  "outletNameText": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__outletNameText",
  "right": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__right",
  "row": "NewOrderOutletDetailsSkeleton-module-scss-module__wc3rOq__row",
});
